import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/patient-ecg-reminder',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/RemindersContainer',
      './modules/reminders'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Reminders = require('./containers/RemindersContainer').default
      const actions = require('./modules/reminders')
      const reducer = require('./modules/reminders').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'reminders', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, Reminders)

    /* Webpack named bundle   */
    }, 'reminders')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Reminders/index.js